import type { ReactNode } from 'react'

export function CardTitle({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <h2 className={`text-lg font-semibold text-slate-900 ${className}`}>
      {children}
    </h2>
  )
}
